// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Ulrich Mierendorff
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : Database Administration and Debugging Parts
// =============================================================================
export const parts = true;
import * as views from './views';
export { views };
